const App = {
  namespaced: true,

  state: {
    drawer: false
  },
  getters: {
    getDrawer: state => state.drawer
  },
  mutations: {
    setDrawer(state, payload) {
      state.drawer = payload;
    }
  },
  actions: {
    setDrawer(context, payload) {
      context.commit("setDrawer", payload);
    }
  }
};

export default App;
